import { createValueProvider } from '../Context';

export const {
  SelectedValueProvider: BookDateSelectedValueProvider,
  useSelectedValue: useBookDateSelectedValue,
  useSetSelectedValue: useSetBookDateSelectedValue,
} = createValueProvider();
